import { createReducer } from '@reduxjs/toolkit';
import { ToBeProcessedItem } from 'modules/contract-processing/types';
import {
  setContractProcessingLoadingAction,
  setContractProcessingDataAction,
  setContractProcessingErrorAction,
  setBulkConfirmErrorsAction,
} from 'store/actions/contract-processing-actions';

export interface IContractProcessingState {
  loading: boolean;
  items: ToBeProcessedItem[];
  totalItems: number;
  error: boolean;
  bulkConfirmErrors: Record<number, string>;
}

const initialState: IContractProcessingState = {
  loading: false,
  items: [],
  totalItems: 0,
  error: false,
  bulkConfirmErrors: {},
};

const contractProcessingReducer = createReducer(initialState, builder => {
  builder
    .addCase(setContractProcessingLoadingAction, (state, action) => ({
      ...state,
      loading: action.payload,
    }))
    .addCase(setContractProcessingDataAction, (state, action) => ({
      ...state,
      items: action.payload.items,
      totalItems: action.payload.totalItems,
    }))
    .addCase(setContractProcessingErrorAction, (state, action) => ({
      ...state,
      error: action.payload,
    }))
    .addCase(setBulkConfirmErrorsAction, (state, action) => ({
      ...state,
      bulkConfirmErrors: action.payload,
    }));
});

export default contractProcessingReducer;
